import { useEffect, useLayoutEffect } from "react";
// import AppRoute from "./routes/AppRoute";
import { selectedTheme } from "./config/themes";
// import BottomTabs from "./components/Navbar/BottomTabs";
import Layout from "./layout/Layout";
import useResponse from "./hooks/useResponse";
import { markUserGestureStart, resetUserGesture } from "./utils/userGesture";
import useDisableZoom from "./hooks/useDisableZoom";
import { useSelector } from "react-redux";
import { initGA, initAW } from "./lib/google";
import { NODE_ENV } from "./utils/environment";

export default function App() {
  useDisableZoom();

  const { isStepperDisabled } = useSelector((state) => state.user);

  const { handleStep, token, location } = useResponse();

  useEffect(() => {
    if (
      token &&
      !isStepperDisabled &&
      location.pathname !== "/" &&
      location.pathname !== "/home" &&
      location.pathname !== "/enter-otp" &&
      location.pathname !== "/confirm-details" &&
      location.pathname !== "/select-loan" &&
      location.pathname !== "/payment-status"
    ) {
      handleStep();
    }
  }, [token]);

  useEffect(() => {
    const theme = selectedTheme();
    Object.keys(theme).forEach((key) => {
      document.documentElement.style.setProperty(`--${key}`, theme[key]);
    });

    if(NODE_ENV === "production") {
      initGA();
      initAW();
      if(!window.clarity) {
        (function (c, l, a, r, i, t, y) {
          c[a] =
            c[a] ||
            function () {
              (c[a].q = c[a].q || []).push(arguments);
            };
            t = l.createElement(r);
            t.async = 1;
            t.src = "https://www.clarity.ms/tag/" + i;
            y = l.getElementsByTagName(r)[0];
            y.parentNode.insertBefore(t, y);
          })(window, document, "clarity", "script", "s50gvgd10v");
        }
      }
  }, []);

  useEffect(() => {
    const gestureEvents = ["click", "change", "input"];

    gestureEvents.forEach((event) => document.addEventListener(event, markUserGestureStart, true));

    return () => {
      gestureEvents.forEach((event) => document.removeEventListener(event, markUserGestureStart, true));
    };
  }, []);

  useLayoutEffect(() => {
    resetUserGesture();
  }, [location.pathname]);

  console.log("App Rendered", process.env.NODE_ENV);


  return (
    <>
      <Layout />
      {/* <AppRoute /> */}
    </>
  );
}
